import { promptVars } from '../variables';
import { structureWithSchemaBasePrompt, } from './structureBasePrompt';
export const generateStructurePersistEventsPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application.')
    .ai(promptVars.structureDsl)
    .human('Check the structure and make sure it has all persist events on all create and edit scopes or views if there is more than on scope.');
//# sourceMappingURL=generateStructurePersistEventsPrompt.js.map